import { createAction, props } from '@ngrx/store';

export const CreateNewIntegration = createAction(
  '[Integration Management: Create New]: Create New Integration',
);

export const InitIntegrationNameSuffix = createAction(
  '[Integration Management: Create New]: Init Integration Name Suffix',
  props<{ integrationNameSuffix: string }>(),
);

export const InitIntegrationDescriptionSuffix = createAction(
  '[Integration Management: Create New]: Init Integration Description Suffix',
  props<{ integrationDescriptionSuffix: string }>(),
);

export const FindAvailableLanguages = createAction(
  '[Integration Management: Create New]:Find Available Languages',
);

export const FindAvailableLanguagesSuccess = createAction(
  '[Integration Management: Create New]: Find Available Languages Success',
  props<{ res: any }>(),
);

export const FindAvailableLanguagesFailed = createAction(
  '[Integration Management: Create New]: Find Available Languages Failed',
  props<{ error: any }>(),
);

export const SelectedIntegrationTypeChanged = createAction(
  '[Integration Management: Create New]: Selected Integration Type Changed',
  props<{ selectedIntegrationType: string }>(),
);
